import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.items = Array.from(this.element.querySelectorAll("[data-home-reveal]"))
    this.smoothLinks = Array.from(this.element.querySelectorAll("[data-smooth-scroll]"))
    this.reducedMotionQuery = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : { matches: false }
    this.handleSmoothScroll = this.handleSmoothScroll.bind(this)

    this.smoothLinks.forEach((link) => {
      link.addEventListener("click", this.handleSmoothScroll)
    })

    if (!this.items.length) return

    this.element.classList.add("is-reveal-ready")

    if (!("IntersectionObserver" in window) || this.reducedMotionQuery.matches) {
      this.revealAll()
      return
    }

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return

        this.reveal(entry.target)
        observer.unobserve(entry.target)
      })
    }, {
      rootMargin: "0px 0px -8% 0px",
      threshold: 0.12
    })

    this.items.forEach((item) => this.observer.observe(item))
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    this.element.classList.remove("is-reveal-ready")

    if (this.smoothLinks) {
      this.smoothLinks.forEach((link) => {
        link.removeEventListener("click", this.handleSmoothScroll)
      })
    }
  }

  revealAll() {
    this.items.forEach((item) => this.reveal(item, { immediate: true }))
  }

  reveal(item, options = {}) {
    item.classList.add("is-visible")

    if (options.immediate) {
      this.clearRevealDelay(item)
      return
    }

    window.setTimeout(() => this.clearRevealDelay(item), 700)
  }

  clearRevealDelay(item) {
    item.style.removeProperty("--home-reveal-delay")
  }

  handleSmoothScroll(event) {
    const href = event.currentTarget.getAttribute("href")
    if (!href || href.charAt(0) !== "#") return

    const target = document.getElementById(href.slice(1))
    if (!target) return

    event.preventDefault()
    target.scrollIntoView({
      behavior: this.reducedMotionQuery.matches ? "auto" : "smooth",
      block: "start"
    })
  }
}
